import { Navigate, useLocation } from 'react-router-dom';

const DashboardRedirect = () => {
  const location = useLocation();
  
  // Preserve query string parameters when redirecting
  return <Navigate to={`/${location.search}`} replace />;
};

export default DashboardRedirect;

